import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-program-summary',
  templateUrl: './program-summary.component.html',
})
export class DashboardV2ProgramSummaryComponent {
  @Input() summary = '';
  @Input() objectives: any[] = [];
  @Input() difficulties: any[] = [];
  @Output() viewAll = new EventEmitter<void>();
}
